<template>
	<v-dialog v-model="dialog" max-width="450px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" class="text-lowercase" icon v-on="on">
				<v-tooltip bottom color="primary">
					<template v-slot:activator="{ on }">
						<v-icon small v-on="on">mdi-delete</v-icon>
					</template>
					<span>{{'delete model' | localize}}</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-show="!loading">
			<v-spacer></v-spacer>
			<v-card-title class="subtitle-1 pt-6 text-pre-wrap">
				{{'Would you like to delete the model' | localize}} 
				<span class="secondary--text">{{product.trademark.name}} {{ product.model }} </span>? &#128576;
			</v-card-title>
			<v-divider />
			<v-card-text class="error--text text-justify">
				{{'Warning' | localize }}: {{'If only one model is assigned to this trademark, the model and the trademark will be deleted automatically' | localize}}.
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="error" text
					class="text-capitalize"
					@click="deleteProduct">
					{{'Yes' | localize}}
				</v-btn>
				<v-btn color="secondary" text
					class="text-capitalize"
					@click="closeDialog">
					{{'No' | localize}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: ['product'],
		data () {
			return	{
				dialog: false
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			products () {
				return this.$store.getters.products;
			}
		},
		methods: {

			async deleteProduct () {
				const suff = this.product.model.split('_')[0];
				if (suff) {
					//update parent product
					const product = this.products?.find((prod) => (prod.model == suff && prod.trademarkId == this.product.trademarkId));
					if (product) {
						// edit old model
						const upgraded = {
							...product,
							available_till: 12
						}

						try {
							await this.$store.dispatch('editTeamProduct', upgraded);
						}
						catch (error) {
							await this.$store.dispatch('setError', error.message)
						}
					}
				}
				
				try {
					await this.$store.dispatch('deleteTeamProduct', this.product.id);
				}
				catch(error) {
					console.log(error.message)
				}	
				this.closeDialog ()				
			},
			
			closeDialog () {
				//reset
				this.dialog = false
			}
		},
	}
</script>
